import { render } from "./PostItem.vue?vue&type=template&id=11e60a58&ts=true"
import script from "./PostItem.vue?vue&type=script&lang=ts"
export * from "./PostItem.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/flowerdiy/flowerdiy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__